// Material rule book — mirror of backend/services/materials.py (keep in sync).
export const CANONICAL_MATERIALS = ['Concrete', 'Clay', 'Galv', 'Zinc', 'Maxam', 'Alu', 'Butynol', 'Polycarbonate',
  'Lead', 'EPDM', 'Copper', 'Steel', 'PVC', 'Other'];

export const MATERIAL_ALIASES = {
  conc: 'Concrete', concrete: 'Concrete', galvanised: 'Galv', galvanized: 'Galv', galv: 'Galv',
  zincalume: 'Zinc', zinc: 'Zinc', maxam: 'Maxam', maxx: 'Maxam', colorsteel: 'Maxam', coloursteel: 'Maxam',
  zinacore: 'Maxam', zincacore: 'Maxam', zcore: 'Maxam', 'z core': 'Maxam',
  alu: 'Alu', aluminium: 'Alu', aluminum: 'Alu', aluguard: 'Alu', membrane: 'Butynol', butynol: 'Butynol',
  polycarbonate: 'Polycarbonate', polycarb: 'Polycarbonate', translucent: 'Polycarbonate', laserlite: 'Polycarbonate',
  topglass: 'Polycarbonate', clears: 'Polycarbonate', solasafe: 'Polycarbonate', clay: 'Clay', lead: 'Lead', epdm: 'EPDM', copper: 'Copper',
  steel: 'Steel', pvc: 'PVC',
  'concrete modern': 'Concrete', 'concrete old': 'Concrete', 'modern concrete': 'Concrete', 'old concrete': 'Concrete',
  'bed & point': 'Concrete',
};

export const canonicalMaterial = (v) => {
  const s = String(v || '').trim();
  return MATERIAL_ALIASES[s.toLowerCase()] || s;
};

// Primary materials per canonical roof type — mirror of backend/data/primary_materials.py.
export const PRIMARY_MATERIALS_BY_ROOF_TYPE = {
  Iron: ['Maxam', 'Galv', 'Zinc', 'Alu'],
  'Tin Tile': ['Maxam', 'Galv'],
  'Modern Concrete': ['Concrete'],
  'Old Concrete': ['Concrete'],
  Clay: ['Clay'],
  Butynol: ['Maxam', 'Galv', 'Zinc', 'Alu'],
  Polycarbonate: ['Polycarbonate'],
};
const ROOF_TYPE_HINTS = [['tin', 'Tin Tile'], ['decra', 'Tin Tile'], ['butynol', 'Butynol'], ['membrane', 'Butynol'],
  ['polycarb', 'Polycarbonate'], ['clear', 'Polycarbonate'], ['old', 'Old Concrete'], ['concrete', 'Modern Concrete'],
  ['conc', 'Modern Concrete'], ['clay', 'Clay'], ['iron', 'Iron']];
export const ALL_PRIMARY_MATERIALS = ['Maxam', 'Galv', 'Zinc', 'Alu', 'Concrete', 'Clay', 'Polycarbonate'];

export const primaryMaterialsForRoof = (roofType) => {
  const rt = String(roofType || '').trim().toLowerCase();
  if (!rt) return ALL_PRIMARY_MATERIALS;
  const exact = Object.keys(PRIMARY_MATERIALS_BY_ROOF_TYPE).find(k => k.toLowerCase() === rt);
  if (exact) return PRIMARY_MATERIALS_BY_ROOF_TYPE[exact];
  const hint = ROOF_TYPE_HINTS.find(([h]) => rt.includes(h));
  return hint ? PRIMARY_MATERIALS_BY_ROOF_TYPE[hint[1]] : ALL_PRIMARY_MATERIALS;
};
